export default [
  `Книга Вероники Сидоровой<br/>«Новые письма к тебе»<br/><br/>
Дорожный набор для ухода за лицом в фирменной косметичке от Institut Esthederm: очищающий крем Osmoclean, сыворотка Age Proteom, увлажняющий крем Eau Cellulaire<br/><br/>
Шампунь и маска L'Oreal Pro Longer`,
  `Книга Вероники Сидоровой<br/>«Новые письма к тебе»<br/><br/> 
Сумка Margaux, The Row`,
  `Книга Вероники Сидоровой<br/>«Новые письма к тебе»<br/><br/>
Тушь Clarins Wonder Volume Mascara XXL<br/><br/>
Шампунь и маска L'Oreal Pro Longer`,
  `Книга Вероники Сидоровой<br/>«Новые письма к тебе»<br/><br/> 
Миндальное масло для душа L’occitane<br/><br/>
Шелковая маска для сна и гребень в кружевном мешочке Primrose`,
  `Книга Вероники Сидоровой<br/>«Новые письма к тебе»<br/><br/>
Кофейник и сахарница из лимитированной серии ИФЗ для Otvet.co`,
  `Книга Вероники Сидоровой<br/>«Новые письма к тебе»<br/><br/> 
Кашемировый свитер Present&Simple`,
  `Книга Вероники Сидоровой<br/>«Новые письма к тебе»<br/><br/> 
Тушь ресниц Clarins Wonder Volume Mascara XXL<br/><br/>
Миндальное масло для душа L’occitane<br/><br/> 
Платочек Otvet.co «С чистого листа»`,
  `Книга Вероники Сидоровой<br/>«Новые письма к тебе»<br/><br/>
Шелковая маска для сна и гребень в кружевном мешочке Primrose<br/><br/>
Лимитированная сахарница ИФЗ для Otvet.co`,
  `Книга Вероники Сидоровой<br/>«Новые письма к тебе»<br/><br/> 
Бомбер с блестками Zarina`,
  `Книга Вероники Сидоровой<br/>«Новые письма к тебе»<br/><br/>
Массажер Bork`,
  `Книга Вероники Сидоровой<br/>«Новые письма к тебе»<br/><br/> 
Шелковая пижама Primerose`,
  `Книга Вероники Сидоровой<br/>«Новые письма к тебе»<br/><br/> 
Дорожный набор для ухода за лицом в фирменной косметичке от Institut Esthederm: очищающий крем Osmoclean, сыворотка Age Proteom, увлажняющий крем Eau Cellulaire<br/><br/>
Тушь Clarins Wonder Volume Mascara XXL<br/><br/>
Платочек Otvet.co «С чистого листа»`,
  `Книга Вероники Сидоровой<br/>«Новые письма к тебе»<br/><br/> 
Кашемировый свитер Present&Simple`,
  `Книга Вероники Сидоровой<br/>«Новые письма к тебе»<br/><br/> 
Кашемировый свитер Present&Simple`,
  `Книга Вероники Сидоровой<br/>«Новые письма к тебе»<br/><br/> 
Шелковая пижама Primerose`,
  `Книга Вероники Сидоровой<br/>«Новые письма к тебе»<br/><br/> 
Шелковая пижама Primerose`,
  `Книга Вероники Сидоровой<br/>«Новые письма к тебе»<br/><br/> 
Дорожный набор для ухода за лицом в фирменной косметичке от Institut Esthederm: очищающий крем Osmoclean, сыворотка Age Proteom, увлажняющий крем Eau Cellulaire<br/><br/>
Шерстяной лонгслив с мохером Zarina`,
  `Книга Вероники Сидоровой<br/>«Новые письма к тебе»<br/><br/> 
Дорожный набор для ухода за лицом в фирменной косметичке от Institut Esthederm: очищающий крем Osmoclean, сыворотка Age Proteom, увлажняющий крем Eau Cellulaire<br/><br/>
Лонгслив с открытыми плечами Zarina`,
  `Книга Вероники Сидоровой<br/>«Новые письма к тебе»<br/><br/> 
Вельветовая рубашка Zarina`,
  `Книга Вероники Сидоровой<br/>«Новые письма к тебе»<br/><br/> 
Толстовка поло из хлопка Zarina`,
  `Книга Вероники Сидоровой<br/>«Новые письма к тебе»<br/><br/> 
Толстовка поло из хлопка Zarina`,
  `Книга Вероники Сидоровой<br/>«Новые письма к тебе»<br/><br/> 
Толстовка поло из хлопка Zarina`,
  `Книга Вероники Сидоровой<br/>«Новые письма к тебе»<br/><br/> 
Оверсайз свитер Zarina`,
]
